import React, { useState } from "react";
import axios from "axios";
import "./App.css";

export default function App() {
  const [city, setCity] = useState("");
  const [temperature, setTemperature] = useState(null);
  const [description, setDescription] = useState("");
  const [icon, setIcon] = useState("");
  const [weatherType, setWeatherType] = useState("");

  function handleSearch(event) {
    event.preventDefault();
    const apiKey = process.env.REACT_APP_OPENWEATHER_KEY;
    if (!apiKey) {
      setDescription("Missing API key. Set REACT_APP_OPENWEATHER_KEY in .env.");
      return;
    }
    const apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;

    axios
      .get(apiUrl)
      .then((response) => {
        setTemperature(response.data.main.temp);
        setDescription(response.data.weather[0].description);
        setIcon(response.data.weather[0].icon);
        setWeatherType(response.data.weather[0].main.toLowerCase()); // e.g., "Clear", "Clouds", "Rain"
      })
      .catch(() => setDescription("City not found or network error."));
  }

  return (
    <div className={`App ${weatherType}`}>
      <h1>🌸 Weather Search Engine</h1>
      <form onSubmit={handleSearch}>
        <input
          type="text"
          placeholder="Enter a city..."
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />
        <button type="submit">Search</button>
      </form>

      {temperature !== null && (
        <div className="weather-result">
          <h2>
            The temperature in <strong>{city}</strong> is{" "}
            <span className="temp">{temperature}°C</span>
          </h2>
          <p className="description">{description}</p>
          <img
            src={`https://openweathermap.org/img/wn/${icon}@2x.png`}
            alt={description}
          />
        </div>
      )}
    </div>
  );
}
